import {
  DataLayer,
  DataLayerCustomEvent,
  DataLayerEcommerceEvent,
} from "./dataLayer.schema";

export function findExistingEcommerceEventsByEventName(
  event: DataLayerEcommerceEvent["event"],
) {
  const events = window.dataLayer?.filter(
    (entry: DataLayer): entry is DataLayerEcommerceEvent =>
      isEcommerceEvent(entry) && entry?.event === event,
  );

  return events?.map(
    (entry: DataLayerEcommerceEvent) => entry.ecommerce?.items?.[0],
  );
}

function isEcommerceEvent(entry: DataLayer): entry is DataLayerEcommerceEvent {
  return entry !== null && entry !== undefined && "ecommerce" in entry;
}

function eventAlreadyExists(
  event: DataLayerCustomEvent | DataLayerEcommerceEvent,
) {
  switch (event.event) {
    /**
     * Only the purhcase event should be unique per transaction ID
     */
    case "purchase": {
      return window.dataLayer.find(
        (entry: DataLayerEcommerceEvent) =>
          entry.ecommerce?.transaction_id === event.ecommerce?.transaction_id,
      );
    }
    default: {
      return false;
    }
  }
}

export function pushGtmEvent(
  event?: DataLayerCustomEvent | DataLayerEcommerceEvent,
) {
  if (typeof window === "undefined") {
    return;
  }

  if (!event) {
    return;
  }

  if (eventAlreadyExists(event)) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}
